<template>
  <div class="MainBox" @click.stop="SelectActive(-1, $self)">
    <div class="TableHead">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="HandleModel(true, 1)"><span
            class="icon iconfont iconicon-test20"></span>新增检测报告</li>
      </ul>
      <ul class="clear"></ul>
    </div>
    <div class="TableMain">
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <table class="table StripeTable" v-else>
        <thead>
          <tr>
            <th>检测报告名称</th>
            <th>模式</th>
            <th>产品批次</th>
            <th>批次ID</th>
            <th>是否对外显示</th>
            <th>创建时间</th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle">
          <tr v-for="(item, index) in datas" v-bind:key="index">
            <td v-text="item.name"></td>
            <td>
              <a v-if="item.model === 1">覆盖模式</a>
              <a v-else>新增模式</a>
            </td>
            <td>
              <a v-text="item.batchName"></a>
            </td>
            <td>
               <a v-text="item.batch_id"></a>
            </td>
            <td>
              <a v-if="item.model === 2">不对外显示</a>
              <a v-else>对外显示</a>
            </td>
            <td v-text="item.create_at"></td>
          </tr>
        </tbody>
      </table>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

      <!-- 码标激活窗口 -->
      <div class="ModalBox" v-if="ModelShow">
        <div class="ModalMain" style="width: 650px;">
          <div class="ModalMainHead">
            新增检测报告
            <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback"
              @click="HandleModel(false, 1)"></span>
          </div>
          <div class="ModalMainBox">
            <ul class="FormStyleTwo">
              <div>
                <p class="FormStyleTwoTitle"><i>*</i>模式</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(1, $self)">
                    {{SelectArr[1].datas[SelectArr[1].ix]}}
                    <ul class="OptionStyleBox" v-if="SelectArr[1].active">
                      <li class="OptionStyleRow" v-for="(item, index) in SelectArr[1].datas" v-bind:key="index" v-text="item" @click="SelectData(1, index)"></li>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                </p>
              </div>
              <div style="margin-top: 10px;">
                <ul class="FormStyleTwo FormStyleTwoRow" v-for="(item, index) in customize_data" v-bind:key="index">
                  <li class="FormStyleTwo" style="padding:2px 0;">
                    <p style="padding-bottom: 5px;">
                      <input class="FormStyleTwoInputLeft" disabled="disabled" v-model="item.key"/>
                      <input class="FormStyleTwoInputRight" disabled="disabled" v-model="item.value"/>
                    </p>
                    <p class="btnArray FormStyleTwoImgBtnArrAbsolute">
                      <a class="btnStyleTwo btnRadius blueBackColor" @click="HandleModel(true,2, index)">检测报告</a>
                      <a class="btnStyleTwo btnRadius redBackColor" @click="RemoveRow(index)">{{$t('c.Common.Delete')}}</a>
                    </p>
                  </li>
                  <li class="FormStyleTwo" style="padding:2px 0;">
                    <p style="padding-bottom: 5px;">是否对外显示：<select v-model="item.show_model">
                      <option key="0" value="1">是</option>
                      <option key="1" value="2">否</option>
                    </select></p>
                  </li>
                  <li class="FormStyleTwo" style="padding:2px 0;">
                    <p style="padding-bottom: 5px;">检测报告名称：<input class="FormStyleTwoInputLeft" v-model="item.csName"/></p>
                  </li>
                  <li class="FormStyleTwo" style="padding:2px 0;">
                    <p style="padding-bottom: 5px;">产品批次：
                      <select v-model="item.batch_model" @change="onChange($event, item)">
                      <option v-for="(option, batchIndex) in batchList" :key="batchIndex" :value="batchIndex" >
                        {{ option.name }}
                      </option>
                    </select>
                    </p>
                  </li>
                  <li class="FormStyleTwo" style="padding:2px 0;">

                  </li>
                </ul>
                <div class="btnStyleTwo greenBackColor btnRadius AddDefine" @click="addAttributeRow"><span class="icon iconfont iconicon-test20"></span>{{$t('b.ProductManage.AddLine')}}</div>
              </div>
            </ul>
          </div>
          <div class="ModalMainFoot">
            <div class="ModalMainFootLeft feedback"><span
                class="icon iconfont iconicon-test28"></span>{{ $t('c.Common.Document') }}</div>
            <div class="ModalMainFootRight btnArray">
              <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false, 1)"
                v-text="$t('c.Common.Cancel')"></a>
              <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm(1)" v-text="$t('c.Common.Confirm')"></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片空间 -->
    <div class="ModalBox" v-if="ModelShow2">
      <div class="ModalMain">
        <div class="ModalMainHead">
          图片空间
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(false, 2)"></span>
        </div>
        <div class="TableHead ModalMainImgHead">
          <ul class="TableHeadLeft">
            <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius">
              <span class="icon iconfont iconicon-test20"></span>上传图片
              <input type="file" class="upload" @change="AddImg()" ref="imgs" multiple accept="image/png,image/jpeg,image/gif,image/jpg"/>
            </li>
          </ul>
          <ul class="TableHeadRight">
            <div class="SelectStyle ModalSelect" @click="SelectActive(0)" v-if="SelectArr[0].datas.length > 0">
              <div class="SelectStyleValue">{{SelectArr[0].datas[SelectArr[0].ix].group_name}}</div>
              <ul class="OptionStyleBox" v-if="SelectArr[0].active">
                <ul class="OptionStyleMain">
                  <li class="OptionStyleRow" v-for="(item,index) in SelectArr[0].datas" v-bind:key="index" v-text="item.group_name" @click="SelectData(0, index, item.space_group_id)"></li>
                </ul>
              </ul>
              <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
            </div>
          </ul>
          <ul class="clear"></ul>
        </div>
        <div class="ModalMainBox">
          <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!imgsList"></K-Transition>
          <div v-else :class="{ModalMainBoxScroll:imgsList.length > 5}">
            <table class="table ModalMainImgBox" >
              <tbody class="TRHoverStyle">
              <tr v-for="(item,index) in imgsList" v-bind:key="index" @click="selectImg(item.url,item.name)">
                <td class="ModalMaiImgMainBox"><div class="ModalMaiImgMain backImg" :style="{backgroundImage: 'url(' + item.url + ')'}"></div></td>
                <td v-text="item.name"></td>
                <td class="ModalMaiImgIconBox"><span class="icon iconfont iconicon-test55 ModalMaiImgIcon"></span></td>
              </tr>
              </tbody>
            </table>
            <!-- 分页器 -->
            <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage2" @SkipPage="SkipPage2"></K-Paging>
          </div>

        </div>
        <div class="ModalMainFoot">
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false, 2)">取消</a>
            <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm(2)">确定</a>
          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
let self;
import axios from 'axios'
import $axios from '@/hooks/axios-common.js'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import SelectView from '@/components/common/SelectView.vue'
export default {
  name: 'ProductManage',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Loading': Loading,
    'K-Toast': Toast,
    'K-Select': SelectView
  },
  data() {
    return {
      ix:0,
      $self: null,
      page: 1,
      page2: 1,
      subHint: '数据加载中...',
      isLoding: true,
      datas: null,
      rootid: null,
      orgid: null,
      totalPages: 0,
      totalPages2: 0,
      ModelShow: false,
      ModelShow2: false,
      ModelTwoShow: false,
      loading: false,
      tradeType: null,
      UploadType:null,
      pix:3, //产品容器索引
      Toast: {
        state: false,
        type: 0,
        txt: null
      },
      SelectArr:[{
        ix:0,
        active:false,
        datas:[]
      },{
        ix:0,
        active:false,
        datas:["覆盖模式", "新增模式"]
      }],
      Codes: [],
      cix:0,
      pid: 0,
      batchList: [],
      code: null,
      exTime: '',
      allProjectData: null,
      first_code: null,
      last_code: null,
      fileTxt: null,
      ac_id: null,
      role: null,
      shop_id: null,
      attribute: {
        ship_date: null
      },
      customize_data: null,
    }
  },
  created() {
    self = this;
    this.$self = this;
    self.rootid = localStorage.getItem("wwmxt_Rootid");
    self.orgid = self.rootid.substring(0, 4);
    self.role = localStorage.getItem("wwmxt_Role");
    self.getBatchList();
    self.GetImgsList();
    self.getList();
  },
  methods: {
    ToastFun(type, txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    SelectData (ix,six, id) {  //选中选择框内容
      self.SelectArr[ix].ix = six;
      self.pid = id;
    },
    ChangeToast() {
      self.Toast.state = false;
    },
    onChange(event, item) {
      const tmpData = self.batchList[event.target.value];
      item.batch_id = tmpData.batch_id;
      item.batch_code = tmpData.batch_ext['batchCode'];
    },
    GetImgsList () {
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+"resource/img/"+self.pid+"/"+self.page2)
          .then(function (response){
            let datas = [];
            for(let item in response.data.meta.data){
              datas.push(response.data.meta.data[item])
              datas[item].active = false;
            }
            self.imgsList = datas;
            self.isLoding = false;

            //总页数
            self.totalPages2 = response.data.meta.last_page;
          }).catch(function (error){
        self.subHint = "数据为空";
        self.isLoding = false;
        self.imgsList = null;
      })
    },
    selectImg (img,name) {
      if(self.UploadType === 1){
        self.datas.logo = img;
      }else{
        self.customize_data[self.cix].key = name;
        self.customize_data[self.cix].value = img;
      }
      self.HandleModel(false);
    },
    AddImg () {
      self.loading = true;

      let inputDOM;
      inputDOM = this.$refs.imgs;
      self.fileLength = inputDOM.files.length;

      //FormDatas格式提交
      let FormDatas = new FormData();
      FormDatas.append("type","img");
      FormDatas.append("space_group_id",self.pid);
      if(self.UploadType == 1){  //logo
        FormDatas.append("belong","logo");
      }else{
        FormDatas.append("belong","blicense");
      }
      for(let i=0;i< inputDOM.files.length;i++){
        FormDatas.append("resource[]",inputDOM.files[i]);
      }

      axios({
        method:"post",
        url:self.GetServerUrl(1)+"resource",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data:FormDatas
      }).then(function (response) {
        self.loading = false;
        if(self.fileLength > response.data.meta.length){
          self.ToastFun(2,"文件必须为图片格式");  //弹窗提醒
        }else{
          self.ToastFun(0,response.data.message);  //弹窗提醒
        }
        self.GetImgsList();
      }).catch(function (error) {
        self.loading = false;
        self.ToastFun(2,"文件必须为图片格式");  //弹窗提醒
      })
    },
    addAttributeRow () {
      if(!self.customize_data){
        self.customize_data = [];
      }
      self.customize_data.push({key:"",value:""});
      self.$forceUpdate();
    },
    RemoveRow (ix) {
      self.customize_data.splice(ix,1);
      self.$forceUpdate();
    },
    ChangePage(data) {  //上下翻页
      if (data.te == 1) {
        if (self.page > 1) {
          self.page--
        }
      } else {
        if (self.page < self.totalPages) {
          self.page++
        }
      }
      self.getList();
    },
    ChangePage2(data) {  //上下翻页
      if (data.te == 1) {
        if (self.page2 > 1) {
          self.page2--
        }
      } else {
        if (self.page2 < self.totalPages2) {
          self.page2++
        }
      }
      self.GetImgsList();
    },
    SkipPage(data) {  //跳转分页
      self.page = data.ix;
      self.getList();
    },
    SkipPage2(data) {  //跳转分页
      self.page2 = data.ix;
      self.GetImgsList();
    },
    SubmitForm() {  //提交表单

      const postData = {
        "enterprise_user_id": self.getSafeCode('enterprise_user_id'),
        "enterprise_id": self.getSafeCode('enterprise_id'),
        "list": self.customize_data,
        "model": self.SelectArr[1].ix + 1};
      axios.post(self.GetServerUrl(1)+"report", postData)
          .then(function (response){
             if (response.data.code === 200) {
               self.getList();
               self.ToastFun(0,response.data.message);  //弹窗提醒
             } else {
               self.subHint = response.data.message;
             }
             self.HandleModel(false, 1);
          }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    getList () {
      self.isLoding = true;
      axios.post(self.GetServerUrl(1)+"reportList", {page: self.page})
          .then(function (response){
            self.datas = response.data.meta.data;
            self.isLoding = false;
          }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    getBatchList () {
      self.datas = null;
      self.isLoding = true;
      axios.post(self.GetServerUrl(1)+"batch_list/1", {no_page: true})
          .then(function (response){
            self.batchList = response.data.meta;
            self.isLoding = false;
          }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    Remove(ix) {
      if (ix == "all") {
        self.Codes = [];
      } else {
        self.Codes.splice(ix, 1);
      }
    },
    HandleModel(status, te, ix) {  //隐藏显示生码模态框
      if (te === 1) {
        self.ModelShow = status;
      } else {
        self.ModelShow2 = status;
        self.UploadType = 2;
        self.cix = ix;
      }

    }
  }
}
</script>

<style scoped>
.iconicon-test38 {
  font-size: 15px !important;
}
</style>
